'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import HotPopTopicCardSkeleton from '@fe-news/components/molecules/Member/HotPopTopicCardSkeleton';

// types
import { HotPopTopicCardProps } from '@fe-news/constants/my-track/type';

const RankingListHotPopTopicCard = dynamic(() => import('./RankingListHotPopTopicCard'), {
  loading: () => <HotPopTopicCardSkeleton />,
  ssr: false
});

const RankingListHotPopTopicCardLazy = (props: HotPopTopicCardProps) => {
  return (
    <Suspense fallback={<HotPopTopicCardSkeleton />}>
      <RankingListHotPopTopicCard {...props} />
    </Suspense>
  );
};

export default RankingListHotPopTopicCardLazy;
